export default {"src":"/_next/static/media/kg.8f22c4fb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};